import Menu from './menu';

export default class MenuDesktop extends Menu {
	constructor(...args) {
		super(...args);

		this._isDesktop = ( ENV.device == 'desktop' );

		if( this._isDesktop ) {

			this.dom.first = null;
			this._previous = {
				x: 0,
				type: ''
			};
			this._retrieveDOM();
		}
	}

	init(){
		super.init();

		if( this._isDesktop )
			this._initEvents();
	}

	_retrieveDOM() {
		super._retrieveDOM();

		this.dom.first = this.dom.component.querySelectorAll('.js-menu-first-level');
		this.dom.menuLeft = this.dom.component.querySelector('.js-left-menu');
		this.dom.menuRight = this.dom.component.querySelector('.js-right-menu');
		
		this.dom.showOthers = this.dom.component.querySelector('.js-show-websites');
		this.dom.showSubs = this.dom.component.querySelectorAll('.js-has-children');
		// this.dom.showLangs = this.dom.component.querySelector('.js-show-lang');
		
		this.dom.secondParent = this.dom.component.querySelector('.js-second-level-parent');
		this.dom.firstbg = this.dom.component.querySelector('.js-background-first');
		this.dom.switcher = this.dom.component.querySelector('.js-switcher');
		
		this.dom.childrenOther = this.dom.component.querySelector('.js-children-other');
		this.dom.childrenLangs = this.dom.component.querySelector('.js-children-langs');

	}

	_initEvents() {
		// MENU LEFT OVER
		for (let i = 0; i < this.dom.first.length; i++) {
			const el = this.dom.first[i];
			el.addEventListener('mouseenter', this.inBar.bind(this, el));
		}
		this.dom.menuLeft.addEventListener('mouseleave', this.outBar.bind(this));

		// MENU SubChildren
		this.dom.showSubs.forEach(children => {
			children.addEventListener('mouseenter', this.showSubLevel.bind(this, 'submenu'));
			children.addEventListener('mouseleave', this.hideSubLevel.bind(this));
		});

		// MENU RIGHT OVER
		this.dom.showOthers.addEventListener('mouseenter', this.showSubLevel.bind(this, 'others'));
		// this.dom.showLangs.addEventListener('mouseenter', this.showSubLevel.bind(this, 'langs'));
		
		this.dom.menuRight.addEventListener('mouseleave', this.hideSubLevel.bind(this));
		// this.dom.showLangs.addEventListener('mouseleave', this.hideSubLevel.bind(this));

		this.dom.secondParent.addEventListener('mouseenter', this.showSubLevel.bind(this, ''));
		this.dom.secondParent.addEventListener('mouseleave', this.hideSubLevel.bind(this));
	}

	showSubLevel(type) {
		this.clearSubLevel();
		console.log('type', type);
		if (type == 'submenu'){
			// this.dom.childrenOther.classList.add('show');
			this._previous.type = type;
		} else if (type == 'others'){
			this.dom.childrenOther.classList.add('show');
			this._previous.type = type;
		} else if (type == 'langs') {
			this.dom.childrenLangs.classList.add('show');
			this._previous.type = type;
		} else {
			if (this._previous.type == 'others'){
				this.dom.childrenOther.classList.add('show');
			} else if (this._previous.type == 'langs') {
				this.dom.childrenLangs.classList.add('show');
			}
		}
		
		this.dom.component.classList.add('open');
	}

	hideSubLevel() {
		this.dom.component.classList.remove('open');
		this.clearSubLevel();
	}

	clearSubLevel() {
		this.dom.childrenOther.classList.remove('show');
		this.dom.childrenLangs.classList.remove('show');
	}

	// UI
	inBar(el) {
		let childPos = el.getBoundingClientRect();
		let parentPos = this.dom.menuLeft.getBoundingClientRect();
		
		let w = el.offsetWidth;
		let x = childPos.left - parentPos.left;

		this.animBar(w, x);
	}

	outBar() {
		this.animBar(0, this._previous.x);
	}

	animBar(w, x) {
		this.dom.switcher.style.width = w + 'px';
		this.dom.switcher.style.transform = 'translate3d(' + x + 'px, 0, 0)';

		this._previous.x = x;
	}

	_toggleBackground() {
		if( window.pageYOffset > 100) {
			this.dom.component.classList.add('fixed');
		} else {
			this.dom.component.classList.remove('fixed');
		}
	}

	_update( pos ) {
		super._update( pos );

		this._toggleBackground();
	}
}



// WEBPACK FOOTER //
// src/js/components/menu/menu.desktop.js